<header
  class="header app-header"
  [ngClass]="currentMode ? 'app-header--' + currentMode : ''"
>
  <div class="app-header__brand">
    <span class="logo-crop"><img src="../../assets/Elixir_Retail.svg" alt="Elixir Retail" /></span>
    <app-festive-doodle size="md"></app-festive-doodle>
  </div>

  <div class="app-header__customer">
    <div class="customer-field">
      <i class="pi pi-search customer-field__icon" aria-hidden="true"></i>
      <div class="customer-field__input">
        <p-autoComplete
          #customerNameAutocomplete
          [(ngModel)]="customerSearchValue"
          [suggestions]="filteredCustomers"
          (completeMethod)="filterCustomers($event)"
          (onSelect)="onCustomerSelectFromAutocomplete($event)"
          (ngModelChange)="onCustomerNameModelChange($event)"
          field="customer_name"
          [dropdown]="false"
          [forceSelection]="false"
          [minLength]="0"
          [showEmptyMessage]="true"
          emptyMessage="No customers found"
          placeholder="Customer name or mobile"
          appendTo="body"
          styleClass="customer-name-autocomplete-header"
          inputStyleClass="info-value"
          [readonly]="isExchangeOrder && !!(mobileNumber && customerName)"
        >
          <ng-template let-customer pTemplate="item">
            <div class="customer-option-header">
              <div class="customer-name-text">{{ customer.customer_name }}</div>
              <div class="customer-mobile-text">{{ customer.mobile_no }}</div>
            </div>
          </ng-template>
        </p-autoComplete>
      </div>
      <button
        type="button"
        class="icon-btn customer-field__action"
        (click)="openCustomerDialog()"
        [title]="hasCustomerInfo() ? 'Edit customer' : 'Add customer'"
        [attr.aria-label]="hasCustomerInfo() ? 'Edit customer' : 'Add customer'"
      >
        <i class="pi" [ngClass]="hasCustomerInfo() ? 'pi-user-edit' : 'pi-user-plus'"></i>
      </button>
    </div>

    <span class="header-chip header-chip--danger" *ngIf="hasOutstandingCredit()" title="Credit outstanding">
      <i class="pi pi-wallet" aria-hidden="true"></i>
      <span class="header-chip__label">Credit</span>
      <span class="num">₹{{ creditOutstanding }}</span>
    </span>

    <span
      class="header-chip header-chip--offer"
      *ngIf="hasLoyaltyPoints()"
      [title]="customerLoyaltyData?.loyality_membership?.expiry_date ? getLoyaltyExpiryText() : 'Loyalty points'"
    >
      <i class="pi pi-gift" aria-hidden="true"></i>
      <span class="num">{{ loyaltyPoints }} pts · ₹{{ loyaltyAmount | number: "1.2-2" }}</span>
      <span
        class="header-chip__meta"
        *ngIf="customerLoyaltyData?.loyality_membership?.expiry_date"
        [ngClass]="getLoyaltyExpiryClass()"
      >
        <i class="pi" [ngClass]="isLoyaltyExpired() ? 'pi-times-circle' : 'pi-calendar'"></i>
        {{ getLoyaltyExpiryText() }}
      </span>
    </span>
  </div>

  <app-festive-lantern></app-festive-lantern>

  <div class="app-header__tools">
    <app-mode-indicator [mode]="currentMode"></app-mode-indicator>

    <div class="header-field pricing-group-badge" *ngIf="isOfferGroupMode">
      <i class="pi pi-tags" aria-hidden="true"></i>
      <div class="pricing-group-dropdown">
        <p-dropdown
          [(ngModel)]="selectedOfferGroupId"
          [options]="pricingGroups"
          optionLabel="name"
          optionValue="id"
          (onChange)="onOfferGroupSelected()"
          placeholder="Pricing group"
          [showClear]="false"
          styleClass="pricing-group-dropdown"
          appendTo="body"
        >
        </p-dropdown>
      </div>
    </div>

    <div class="header-field header-date" title="Invoice date">
      <i class="pi pi-calendar" aria-hidden="true"></i>
      <p-calendar
        *ngIf="shouldShowDatePicker()"
        id="currentdate"
        name="currentdate"
        [(ngModel)]="currentDate"
        dateFormat="dd M yy"
        (onSelect)="onDateChange($event)"
        (onInput)="onDateInput($event)"
        (onBlur)="onDateBlur()"
        appendTo="body"
        styleClass="current-date-calendar"
        inputStyleClass="current-date-input"
        [maxDate]="maxDate"
        [showTime]="false"
        [inline]="false"
        [keepInvalid]="false"
      >
      </p-calendar>
      <span *ngIf="!shouldShowDatePicker()" class="header-date__text num">{{
        currentDate | date: "dd MMM yyyy"
      }}</span>
    </div>

    <!-- Network Status Indicator: only visible when state is non-NORMAL -->
    <app-network-status-indicator></app-network-status-indicator>

    <div
      class="session-warning-banner"
      *ngIf="showSessionWarning"
      role="alert"
      [ngClass]="{
        'warning-timeout': sessionWarningType === 'timeout',
        'warning-outside': sessionWarningType === 'outside',
        'warning-error': sessionWarningType === 'error',
        'warning-critical': sessionWarningType === 'critical',
      }"
    >
      <i
        class="pi"
        [ngClass]="{
          'pi-clock': sessionWarningType === 'timeout',
          'pi-exclamation-triangle':
            sessionWarningType === 'outside' || sessionWarningType === 'error',
          'pi-times-circle': sessionWarningType === 'critical',
        }"
      ></i>
      <span class="warning-message">{{ sessionWarningMessage }}</span>
      <button
        type="button"
        class="warning-dismiss-btn"
        *ngIf="sessionWarningType === 'timeout' || sessionWarningType === 'outside'"
        (click)="dismissSessionWarning()"
        title="Dismiss"
      >
        <i class="pi pi-times"></i>
      </button>
      <button
        type="button"
        class="warning-logout-btn"
        *ngIf="sessionWarningType === 'error' || sessionWarningType === 'critical'"
        (click)="forceLogout()"
        title="Logout"
      >
        <i class="pi pi-sign-out"></i>
        <span>Logout</span>
      </button>
    </div>

    <button
      type="button"
      class="icon-btn"
      *ngIf="isShippingDetailsEnabled"
      (click)="openShippingDialog()"
      title="Shipping & transport details"
      aria-label="Shipping and transport details"
    >
      <i class="pi pi-truck"></i>
    </button>
    <button
      type="button"
      class="icon-btn"
      (click)="showKeyboardShortcuts = true"
      title="Keyboard shortcuts (Ctrl+H)"
      aria-label="Keyboard shortcuts"
    >
      <i class="pi pi-question-circle"></i>
    </button>

    <div class="user-profile-wrapper">
      <button
        type="button"
        class="user-profile"
        [class.suspense-mode]="isSuspenseMode"
        (click)="toggleUserMenu($event)"
        [attr.aria-expanded]="showUserMenu"
        aria-haspopup="menu"
      >
        <span class="user-avatar" (click)="generateRandomAvatar(); $event.stopPropagation()">{{
          randomAvatar
        }}</span>
        <span class="user-info">
          <span class="user-name">{{ empCode || userName || "User" }}</span>
          <span class="user-role">{{ salesRep || "User" }}</span>
        </span>
        <i class="pi pi-chevron-down user-caret" aria-hidden="true"></i>
      </button>

      <div class="user-profile-menu" *ngIf="showUserMenu" role="menu">
        <div class="menu-item switch-label" role="menuitem" *ngIf="showSwitchCompany" (click)="toggleAccountList($event)">
          <i class="pi pi-building"></i>
          <span>Switch company</span>
          <i class="pi menu-item__caret" [ngClass]="showAccountList ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </div>
        <div class="account-list" *ngIf="showSwitchCompany && showAccountList">
          <div
            class="account-item"
            *ngFor="let account of posAccounts"
            [class.active]="account.active"
            (click)="switchCompany(account, $event)"
          >
            <i class="pi" [ngClass]="account.active ? 'pi-check-circle' : 'pi-building'"></i>
            <div class="account-text">
              <span class="account-name">{{ account.clientName }}</span>
              <small>
                {{ account.userName }}<span *ngIf="account.storeName"> · {{ account.storeName }}</span>
                <span *ngIf="account.expired" class="expired-tag"> · sign in again</span>
              </small>
            </div>
          </div>
          <div class="account-item add-account" (click)="addCompanyAccount($event)">
            <i class="pi pi-plus-circle"></i>
            <div class="account-text"><span class="account-name">Add another account</span></div>
          </div>
        </div>
        <div class="menu-separator" *ngIf="showSwitchCompany"></div>
        <div class="menu-item menu-item--danger" role="menuitem" (click)="handleLogout()">
          <i class="pi pi-sign-out"></i>
          <span>Log out</span>
          <span class="kbd">F10</span>
        </div>
      </div>
    </div>
  </div>
</header>

<app-announcement-marquee></app-announcement-marquee>

<app-festive-fireworks
  *ngIf="celebrationGreeting"
  intensity="celebrate"
  [duration]="3200"
  [greeting]="celebrationGreeting"
  subtitle="Wishing you a bright and prosperous season"
  (finished)="celebrationGreeting = ''"
></app-festive-fireworks>

<!-- Dedicated Network Status Toast (key="network") -->
<!-- This keeps network notifications visually separate from business toasts. -->
<!-- Positioned top-center for high visibility without blocking POS UI. -->
<p-toast
  key="network"
  position="top-right"
  [baseZIndex]="9999"
  styleClass="network-toast"
></p-toast>

<!-- Keyboard Shortcuts Help Dialog -->
<p-dialog
  [(visible)]="showKeyboardShortcuts"
  [modal]="true"
  [closable]="true"
  [showHeader]="false"
  styleClass="pos-dlg pos-dlg-lg premium-dialog"
  [draggable]="false"
  [resizable]="false"
>
  <div class="premium-header">
    <div class="premium-header-content">
      <h3 class="premium-title">Keyboard Shortcuts</h3>
      <p class="premium-subtitle">Press Ctrl+H any time to see this list</p>
    </div>
    <button type="button" class="premium-close-btn" (click)="showKeyboardShortcuts = false" aria-label="Close">
      <i class="pi pi-times"></i>
    </button>
  </div>
  <div class="shortcuts-content premium-body">
    <div class="shortcuts-section">
      <h6 class="shortcuts-category">Function Keys</h6>
      <div class="shortcuts-grid">
        <div class="shortcut-item">
          <span class="shortcut-key">F1</span>
          <span class="shortcut-description">Print Invoice</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">F2</span>
          <span class="shortcut-description">Show Transaction History</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">F3</span>
          <span class="shortcut-description">Sales Return / Exchange</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">F4</span>
          <span class="shortcut-description">Hold Receipt</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">F5</span>
          <span class="shortcut-description">Reset</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">F6</span>
          <span class="shortcut-description">Resume Receipt</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">F7</span>
          <span class="shortcut-description"
            >Process Order/Exchange/Quotation</span
          >
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">F8</span>
          <span class="shortcut-description">Process Order (same as F7)</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">F9</span>
          <span class="shortcut-description">Delete Item</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">F10</span>
          <span class="shortcut-description">Log Out</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">F11</span>
          <span class="shortcut-description">Cash Management</span>
        </div>
        <div class="shortcut-item" *ngIf="isDenominationEnabled">
          <span class="shortcut-key">F12</span>
          <span class="shortcut-description">Denomination</span>
        </div>
      </div>
    </div>

    <div class="shortcuts-section">
      <h6 class="shortcuts-category">Control Keys</h6>
      <div class="shortcuts-grid">
        <div class="shortcut-item" *ngIf="isBarcodeEnabled">
          <span class="shortcut-key">Ctrl+1</span>
          <span class="shortcut-description">Focus Barcode Search</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">Ctrl+2</span>
          <span class="shortcut-description">Focus Product Search</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">Ctrl+3</span>
          <span class="shortcut-description">Toggle Discount</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">Ctrl+H</span>
          <span class="shortcut-description">Show Keyboard Shortcuts</span>
        </div>
      </div>
    </div>

    <div
      class="shortcuts-section"
      *ngIf="
        modePermissions.quotationMode ||
        modePermissions.wholesaleMode ||
        modePermissions.suspenseMode ||
        modePermissions.pricingGroupMode
      "
    >
      <h6 class="shortcuts-category">Special Keys</h6>
      <div class="shortcuts-grid">
        <div class="shortcut-item" *ngIf="modePermissions.quotationMode">
          <span class="shortcut-key">Alt+Q</span>
          <span class="shortcut-description">Toggle Quotation Mode</span>
        </div>
        <div class="shortcut-item" *ngIf="modePermissions.wholesaleMode">
          <span class="shortcut-key">Alt+W</span>
          <span class="shortcut-description">Toggle Wholesale Mode</span>
        </div>
        <div class="shortcut-item" *ngIf="modePermissions.pricingGroupMode">
          <span class="shortcut-key">Alt+O</span>
          <span class="shortcut-description">Toggle Offer Group Mode</span>
        </div>
        <!--   <div class="shortcut-item" *ngIf="modePermissions.suspenseMode">
                    <span class="shortcut-key">Alt+M</span>
                    <span class="shortcut-description">Toggle Suspense Mode</span>
                </div> -->
      </div>
    </div>

    <div class="shortcuts-section">
      <h6 class="shortcuts-category">Navigation</h6>
      <div class="shortcuts-grid">
        <div class="shortcut-item">
          <span class="shortcut-key">↑ ↓</span>
          <span class="shortcut-description">Navigate Lists</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">Ctrl+← →</span>
          <span class="shortcut-description">Switch History Tabs</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">Enter</span>
          <span class="shortcut-description">Select Item</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">Tab</span>
          <span class="shortcut-description">Next Field</span>
        </div>
        <div class="shortcut-item">
          <span class="shortcut-key">Esc</span>
          <span class="shortcut-description">Cancel/Close</span>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<div id="main">
  <router-outlet></router-outlet>
</div>

<!-- i didnt remove this intentionally - will do it as cleanup when all the functionalites are tested and confirmed by QA-->
<footer *ngIf="false">
  <div
    class="footer-box footer-box-blue"
    [class.disabled]="isQuotationMode || isDeleteMode"
    role="button"
    (click)="!isQuotationMode && !isDeleteMode && emitEvent('F2')"
  >
    <i class="pi pi-list"></i>
    <div class="footer-text">
      <div class="footer-label">View History</div>
      <div class="footer-key">F2</div>
    </div>
  </div>
  <div
    class="footer-box footer-box-light"
    [class.disabled]="isQuotationMode || isDeleteMode || isOfferGroupMode"
    role="button"
    (click)="
      !isQuotationMode && !isDeleteMode && !isOfferGroupMode && emitEvent('F3')
    "
  >
    <i class="pi pi-refresh"></i>
    <div class="footer-text">
      <div class="footer-label">Exchange Item</div>
      <div class="footer-key">F3</div>
    </div>
  </div>
  <div
    class="footer-box footer-box-light"
    [class.disabled]="isQuotationMode || isDeleteMode"
    role="button"
    (click)="!isQuotationMode && !isDeleteMode && emitEvent('F4')"
  >
    <i class="pi pi-pause"></i>
    <div class="footer-text">
      <div class="footer-label">Hold Receipt</div>
      <div class="footer-key">F4</div>
    </div>
  </div>
  <div
    class="footer-box footer-box-light"
    [class.disabled]="isQuotationMode || isDeleteMode"
    role="button"
    (click)="!isQuotationMode && !isDeleteMode && emitEvent('F5')"
  >
    <i class="pi pi-replay"></i>
    <div class="footer-text">
      <div class="footer-label">Reset</div>
      <div class="footer-key">F5</div>
    </div>
  </div>
  <div
    class="footer-box footer-box-light"
    [class.disabled]="isQuotationMode || isDeleteMode"
    role="button"
    (click)="!isQuotationMode && !isDeleteMode && emitEvent('F6')"
  >
    <i class="pi pi-play"></i>
    <div class="footer-text">
      <div class="footer-label">Resume Receipt</div>
      <div class="footer-key">F6</div>
    </div>
  </div>
  <div
    class="footer-box footer-box-light"
    role="button"
    (click)="emitEvent('F9')"
  >
    <i class="pi pi-trash"></i>
    <div class="footer-text">
      <div class="footer-label">
        {{ isDeleteMode ? "Exit Delete Mode" : "Delete Item" }}
      </div>
      <div class="footer-key">F9</div>
    </div>
  </div>
  <!-- <div class="footer-box footer-box-light"
         [class.disabled]="isQuotationMode"
         role="button"
         (click)="!isQuotationMode && emitEvent('F10')">
        <i class="pi pi-sign-out"></i>
        <div class="footer-text">
            <div class="footer-label">Log Out</div>
            <div class="footer-key">F10</div>
        </div>
    </div> -->
  <div
    class="footer-box footer-box-light"
    [class.disabled]="isQuotationMode || isDeleteMode"
    role="button"
    (click)="!isQuotationMode && !isDeleteMode && emitEvent('F11')"
  >
    <i class="pi pi-wallet"></i>
    <div class="footer-text">
      <div class="footer-label">Cash Management</div>
      <div class="footer-key">F11</div>
    </div>
  </div>
  <div
    class="footer-box footer-box-light"
    [class.disabled]="isQuotationMode || isDeleteMode"
    role="button"
    (click)="!isQuotationMode && !isDeleteMode && emitEvent('F12')"
  >
    <i class="pi pi-money-bill"></i>
    <div class="footer-text">
      <div class="footer-label">Denomination</div>
      <div class="footer-key">F12</div>
    </div>
  </div>
</footer>

<!-- Customer Form Dialog -->
<app-customer-form
  [(visible)]="showCustomerDialog"
  [mode]="customerDialogMode"
  [customerData]="currentCustomer"
  [pricingGroups]="pricingGroups"
  (onSave)="handleCustomerSave($event)"
  (onCancel)="handleCustomerCancel()"
>
</app-customer-form>

<!-- Shipping and Transport Details Dialog -->
<p-dialog
  [(visible)]="showShippingDialog"
  [modal]="true"
  [closable]="true"
  [showHeader]="false"
  styleClass="pos-dlg pos-dlg-md premium-dialog"
  [draggable]="false"
  [resizable]="false"
  (onShow)="shippingAddress1Input.focus()"
>
  <div class="premium-header">
    <div class="premium-header-content">
      <h3 class="premium-title">Shipping &amp; Transport</h3>
      <p class="premium-subtitle">Printed on the invoice for this bill</p>
    </div>
    <button type="button" class="premium-close-btn" (click)="cancelShippingDialog()" aria-label="Close">
      <i class="pi pi-times"></i>
    </button>
  </div>
  <div class="shipping-form premium-body">
    <!-- Shipping Address Section -->
    <h6 class="form-section-title mb-3">
      <i class="pi pi-map-marker me-2"></i>Shipping Address
    </h6>
    <div class="row g-3 mb-4">
      <div class="col-md-6">
        <label for="shippingAddress1" class="form-label">Address Line 1</label>
        <input
          type="text"
          id="shippingAddress1"
          #shippingAddress1Input
          class="form-control"
          [(ngModel)]="shippingAddress1"
          placeholder="Enter address line 1"
        />
      </div>
      <div class="col-md-6">
        <label for="shippingAddress2" class="form-label">Address Line 2</label>
        <input
          type="text"
          id="shippingAddress2"
          class="form-control"
          [(ngModel)]="shippingAddress2"
          placeholder="Enter address line 2"
        />
      </div>
      <div class="col-md-4">
        <label for="shippingCity" class="form-label">City</label>
        <input
          type="text"
          id="shippingCity"
          class="form-control"
          [(ngModel)]="shippingCity"
          placeholder="Enter city"
        />
      </div>
      <div class="col-md-4">
        <label for="shippingState" class="form-label">State</label>
        <input
          type="text"
          id="shippingState"
          class="form-control"
          [(ngModel)]="shippingState"
          placeholder="Enter state"
        />
      </div>
      <div class="col-md-4">
        <label for="shippingPincode" class="form-label">Pincode</label>
        <input
          type="text"
          id="shippingPincode"
          class="form-control"
          [(ngModel)]="shippingPincode"
          (input)="onShippingPincodeInput($event)"
          (blur)="onShippingPincodeBlur()"
          placeholder="Enter pincode"
          maxlength="6"
          inputmode="numeric"
        />
        <small *ngIf="shippingPincodeError" class="text-danger d-block mt-1">{{ shippingPincodeError }}</small>
      </div>
    </div>

    <!-- Transport Details Section -->
    <h6 class="form-section-title mb-3">
      <i class="pi pi-truck me-2"></i>Transport Details
    </h6>
    <div class="row g-3">
      <div class="col-md-6">
        <label for="transportLrNo" class="form-label">LR No</label>
        <input
          type="text"
          id="transportLrNo"
          class="form-control"
          [(ngModel)]="transportLrNo"
          placeholder="Enter LR number"
        />
      </div>
      <div class="col-md-6">
        <label for="transportVehicleNo" class="form-label">Vehicle No</label>
        <input
          type="text"
          id="transportVehicleNo"
          class="form-control"
          [(ngModel)]="transportVehicleNo"
          placeholder="Enter vehicle number"
        />
      </div>
      <div class="col-md-6">
        <label for="transporterName" class="form-label">Transporter Name</label>
        <input
          type="text"
          id="transporterName"
          class="form-control"
          [(ngModel)]="transporterName"
          placeholder="Enter transporter name"
        />
      </div>
      <div class="col-md-6">
        <label for="transportDeliveryChallan" class="form-label"
          >Delivery Challan</label
        >
        <input
          type="text"
          id="transportDeliveryChallan"
          class="form-control"
          [(ngModel)]="transportDeliveryChallan"
          placeholder="Enter delivery challan"
        />
      </div>
    </div>
  </div>

  <div class="premium-footer">
    <button type="button" class="premium-btn premium-btn-secondary" (click)="cancelShippingDialog()">
      <i class="pi pi-times"></i>Cancel
    </button>
    <button type="button" class="premium-btn premium-btn-primary" (click)="saveShippingDetails()">
      <i class="pi pi-check"></i>Save
    </button>
  </div>
</p-dialog>

<!-- Cash Out Dialog - shown before logout if required -->
<p-dialog
  [(visible)]="showCashOutDialog"
  [modal]="true"
  [closeOnEscape]="canSkipCashOut"
  [closable]="canSkipCashOut"
  [showHeader]="false"
  [baseZIndex]="10002"
  [draggable]="false"
  [resizable]="false"
  styleClass="pos-dlg pos-dlg-md premium-dialog cash-out-dialog"
>
  <!-- Body and footer come from app-cash-denomination; close only when the cash out may be skipped -->
  <div class="premium-header">
    <div class="premium-header-content">
      <h3 class="premium-title">Closing Cash Entry</h3>
      <p class="premium-subtitle">Count the cash in the drawer before you log out</p>
    </div>
    <button
      *ngIf="canSkipCashOut"
      type="button"
      class="premium-close-btn"
      (click)="showCashOutDialog = false"
      aria-label="Close"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>
  <!-- *ngIf: projected content is created even while the dialog is closed, and its init calls the denomination APIs -->
  <app-cash-denomination
    *ngIf="isDenominationEnabled"
    [mode]="'dialog'"
    [initialTab]="'dayOut'"
    [canSkip]="canSkipCashOut"
    (onComplete)="onCashOutComplete($event)"
  ></app-cash-denomination>
</p-dialog>
